// // IMPORT ICONS
// import adhd from '../../assets/track_icons/ADHD.webp';
// import community_nursing from '../../assets/track_icons/community_nursing.webp';
// import emergency_trauma_nursing from '../../assets/track_icons/emergency&trauma_nursing.webp';
// import geriatric_nursing from '../../assets/track_icons/geriatric_nursing.webp';
// import neonatal_nursing from '../../assets/track_icons/neonatal_nursing.webp';
// import oncology_cancer_care from '../../assets/track_icons/oncology&Cancer_care.webp';
// import pediatric_nursing from '../../assets/track_icons/pediatric_nursing.webp';
// import autism from '../../assets/track_icons/Autism.webp';
// import critical_care_nursing from '../../assets/track_icons/critical_care_nursing.webp';
// import epidemiology from '../../assets/track_icons/Epidemiology.webp';
// import infection_control_prevention from '../../assets/track_icons/infection_control_prevention.webp';
// import neurodiversity from '../../assets/track_icons/Neurodiversity.webp';
// import pain_management from '../../assets/track_icons/pain_management.webp';
// import radiology_nursing from '../../assets/track_icons/Radiology_nursing.webp';
// import chronic_disease_management from '../../assets/track_icons/chronic_disease_management.webp';
// import dentistry from '../../assets/track_icons/Dentistry.webp';
// import genetic_disorder from '../../assets/track_icons/genetic_disorder.webp';
// import mental_health_nursing from '../../assets/track_icons/mental_health_nursing.webp';
// import neurological_nursing from '../../assets/track_icons/neurological_nursing.webp';
// // import palliative_care from '../../assets/track_icons/Palliative Care.webp';
// import reproductive_health from '../../assets/track_icons/reproductive_health.webp';

// // EXPORT TRACKS
// export const tracks = [
//   { name: "ADHD", icon: adhd },
//   { name: "Community Nursing", icon: community_nursing },
//   { name: "Emergency & Trauma Nursing", icon: emergency_trauma_nursing },
//   { name: "Geriatric Nursing", icon: geriatric_nursing },
//   { name: "Neonatal Nursing", icon: neonatal_nursing },
//   { name: "Oncology & Cancer Care", icon: oncology_cancer_care },
//   { name: "Pediatric Nursing", icon: pediatric_nursing },
//   { name: "Autism", icon: autism },
//   { name: "Critical Care Nursing", icon: critical_care_nursing },
//   { name: "Epidemiology", icon: epidemiology },
//   { name: "Infection Control & Prevention", icon: infection_control_prevention },
//   { name: "Neurodiversity", icon: neurodiversity },
//   { name: "Pain Management", icon: pain_management },
//   { name: "Radiology Nursing", icon: radiology_nursing },
//   { name: "Chronic Disease Management", icon: chronic_disease_management },
//   { name: "Dentistry", icon: dentistry },
//   { name: "Genetic Disorders", icon: genetic_disorder },
//   { name: "Mental Health Nursing", icon: mental_health_nursing },
//   { name: "Neurological Nursing", icon: neurological_nursing },
//   // { name: "Palliative Care", icon: palliative_care },
//   { name: "Reproductive Health", icon: reproductive_health }
// ];

import brain from "../../assets/track_icons/brain.webp";
import robot from "../../assets/track_icons/robot.webp";
import software from "../../assets/track_icons/software-application.webp";
import chemical from "../../assets/track_icons/solar-energy.webp";
import Robotics from "../../assets/track_icons/brain.webp";
import Aero from "../../assets/track_icons/airplane.webp";
import Industrial from "../../assets/track_icons/factory.webp";
import Auto from "../../assets/track_icons/electric-vehicle.webp";
import civil from "../../assets/track_icons/worker.webp";
import cyber from "../../assets/track_icons/cyber-security.webp";
import energy from "../../assets/track_icons/engery.webp";
import mech from "../../assets/track_icons/system.webp";
import space from "../../assets/track_icons/space.webp";
import sta from "../../assets/track_icons/satellite.webp";
import human from "../../assets/track_icons/self-employed.webp";
import quantum from "../../assets/track_icons/software-application.webp";
import solar from "../../assets/track_icons/solar-energy.webp";
import network from "../../assets/track_icons/networking.webp";
import digital from "../../assets/track_icons/software-application.webp";
import agriculture from "../../assets/track_icons/agriculture.webp"
import crypto from "../../assets/track_icons/cryptography.webp"
import optics from "../../assets/track_icons/internet.webp"
import software1 from "../../assets/track_icons/development.webp"
import communication1  from "../../assets/track_icons/meeting.webp"
import dna from "../../assets/track_icons/dna.webp"
import modern from "../../assets/track_icons/modernization.webp"
import applications from "../../assets/track_icons/application.webp"
import atom from "../../assets/track_icons/atom.webp"
import education from "../../assets/track_icons/online-education.webp"
import roboto from "../../assets/track_icons/robot (1).webp"
export const tracks = [
  { name: "Quantum AI", icon: robot },
  { name: "Core Quantum Science", icon: software },
  { name: "Machine Learning", icon: brain },
  { name: "Cryptography & Cybersecurity", icon: crypto },
  { name: "Quantum Computation", icon:  Robotics },
  { name: "Optics & Photonics", icon: optics },
  { name: "Software Devolpment", icon: software1 },
  { name: "Communication & Networking", icon: communication1 },
  { name: "Quantum Biology", icon: dna },
  { name: "Quantum Sensing and Metrology", icon: cyber },
  { name: "Quantum Chemistry", icon: energy },
  { name: "Modern Spectroscopy", icon: modern },
  { name: "Quantum Applications", icon:applications },
  { name: "Quantum Cosmology", icon: atom },
  { name: "Materials & Devices", icon: human },
  { name: "Industry & Future", icon:Industrial  },
  // { name: "Quantum Cosmology", icon: solar },
  { name: "Quantum Agriculture", icon: agriculture },
 { name: "Quantum Education & Training", icon: education },
 { name: "Robotics & Automation", icon: roboto },
  //   { name: "Digital Health", icon: digital_health },
  //   { name: "Phytotherapy", icon: phytotherapy },
];
